export const  GOOGLE_TAG_MANAGER_ID = 'G-VPDPZMNKGD'
